/* 🤖 this file was generated by script */
export const wiconServer02 = {
  name: 'server_02',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 8h.01M6 16h.01M6 12h12M6 12a4 4 0 010-8h12a4 4 0 010 8M6 12a4 4 0 000 8h12a4 4 0 000-8"/></svg>`,
};
